import api from '@/services/base.service'

const methods = {
  getTiposEntregaByBodega(bodegaId) {
    return api.get(`/tiposEntregaBodega/${bodegaId}/tipos-entrega`)
  },
  updateTiposEntregaByBodegaAndTipoEntrega(bodegaId, tipoEntrega, json) {
    return api.put(
      `/tiposEntregaBodega/${bodegaId}/tipos-entrega/${tipoEntrega}`,
      json
    )
  },
  getTiposEntregaAsignacionByBodega(bodegaId, tipoEntrega) {
    return api.get(
      `/tiposEntregaBodega/${bodegaId}/tipos-entrega/${tipoEntrega}/asignacion`
    )
  },
  updateAsignacionByTiposEntregaAndBodega(bodegaId, tipoEntrega, json) {
    return api.put(
      `/tiposEntregaBodega/${bodegaId}/tipos-entrega/${tipoEntrega}/asignacion`,
      json
    )
  }
}

export default methods
